import React from 'react'

export default class Messages extends React.Component {
	onChangeMessages = (msgs) => {
		this.forceUpdate();
	}

	componentDidMount() {
		messages.flush();
		this.handlerChange = messages.addHandler(this.onChangeMessages);
	}

	componentWillUnmount() {
		messages.removeHandler(this.handlerChange);
	}

	render() {
		const msgs = messages.msgs.map(( msg, i ) => {
			const cn = 'alert alert-' + (!msg.type ? 'success' : msg.type);
			const _msg = typeof msg.msg === 'string' ? msg : msg.msg;

			return (
				<div className={cn} key={i}>
					<button className="close" title={__('attrs_close')} onClick={() => { messages.remove(msg); }}>
						<em className="la la-times" />
					</button>
					<span dangerouslySetInnerHTML={{__html: _msg.msg}} title={_msg.title || null} />
				</div>
			);
		});
		return(
			<div className="messages">{msgs}</div>
		);
	}
}
